import React from 'react'
import { isInViewport } from 'src/utils'

/**
 * Returns true if the given element is in the viewport
 */
export function useIsInViewport(
    elementRef: React.RefObject<HTMLImageElement | null>
) {
    const [inViewport, setInViewport] = React.useState(false)

    React.useLayoutEffect(() => {
        if (isInViewport(elementRef.current)) {
            setInViewport(true)
        }
    }, [elementRef])

    return inViewport
}
